import { type DocumentDetailsRelease, type IdAndTitle } from "~/api/types";
import InviteReadersModal from "~/organisms/InviteReadersModal";
import { ReadersOverview } from "~/organisms/ReadersOverview";
import { canInviteReaders } from "~/helpers/documentPermissions";

interface Props {
  release: DocumentDetailsRelease;
  category: IdAndTitle | null;
}

export const ReadersOverviewTab = ({ release, category }: Props) => {
  const isInviteAllowed = canInviteReaders(release);

  return (
    <div className="grid gap-4">
      {isInviteAllowed && (
        <InviteReadersModal releaseId={release.id} category={category} />
      )}

      <ReadersOverview
        releaseId={release.id}
        isRemoveAllowed={isInviteAllowed}
      />
    </div>
  );
};
